module.exports = __webpack_public_path__ + "static/media/arrow-right.b884fb7a.svg";